export default __webpack_public_path__ + "static/11017-c4252aadfa63831fccd9e9e8e1f6a6ef.jpg";